import { api } from "../utils/apiClient";

// Mirrors the backend's `ReportType` values accepted by /trends/{report_type}[/groups].
// Shared here so report screens linking into Trends (Report.jsx, VisibilityReport.jsx,
// OTAReport.jsx) don't each hardcode their own copy of these strings.
export const TREND_REPORT_TYPE = {
  AUDIT: "audit",
  LLM_VISIBILITY: "llm_visibility",
  PERSONA: "persona",
  OTA_VS_DIRECT: "ota_vs_direct",
  PERCEPTION: "perception",
};

export const getTrendGroups = (reportType, config) =>
  api.get(`/trends/${reportType}/groups`, false, config);

export const getTrendSeries = (reportType, groupKey, config) =>
  api.get(
    `/trends/${reportType}${groupKey ? `?group_key=${encodeURIComponent(groupKey)}` : ""}`,
    false,
    config,
  );
